module.exports = __webpack_public_path__ + "img/2.a1057635.jpg";